import React, {Component, Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {PERMISSION} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import {Link} from "react-router-dom";
import swal from "sweetalert";
import Select from "react-select";
import {Button, Card, CardHeader, CardTitle, Col, FormGroup, Input, Label, Row,} from "reactstrap";
import DataTable from "react-data-table-component";
import {
    actionAddUpdateRole,
    actionGetPermissions,
    actionGetRole,
    actionGetSingleRoleDetails
} from "../../actions/profile";
import NotFound from "../layout/NotFound";
import DataNotFound from "../common/DataNotFound";
import SelectBoxListLoader from "./selectBoxListLoader";
import HeroSection from "../common/HerroSection/hero-section";
import CommanSidebar from "../common/commanSidebar";
// import { Accordion, AccordionItem, Tooltip } from "carbon-components-react";
// import 'carbon-components/scss/globals/scss/styles.scss';
// import 'carbon-components/css/carbon-components.css';

class Permission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_lastData: true,
            q: '',
            offset: '',
            limit: '',
            searchValue: '',
            role_id: '',
            permission: [],
            errors: {},
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = "Permission | Prime Private Network";
        this.props.actionGetRole();
        this.props.actionGetPermissions();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.role !== this.props.role) {
            this.setState({allUsers: this.props.role});
            /* const request = {
                 q :this.state.q,
                 offset :this.state.offset,
                 limit:this.state.limit
             };
             this.props.actionGetAgentsByRoll(request);*/
        }
        if (prevProps.singleRoleDetails !== this.props.singleRoleDetails) {
            // console.log(this.props.singleRoleDetails.permissions, "this.props.singleRoleDetails.permissions")
            // console.log(this.props.permissions, "this.props.permissions.")

            // (this.props.permissions && this.props.permissions.length > 0) && this.props.permissions.map(p=> (p._id === this.props.singleRoleDetails.permissions &&this.props.singleRoleDetails.permissions.map(d=>d))&&
            //     console.log("true")
            //     // value: p._id,
            //     // label: p.name,
            // )


            ((this.props.singleRoleDetails && this.props.singleRoleDetails.permissions) && this.props.singleRoleDetails.permissions.length > 0) && this.setState({
                permission: this.props.singleRoleDetails.permissions
            });
        }
        if (prevState.role_id !== this.state.role_id) {
            this.props.actionGetPermissions();
        }
    }

    handleAddUpdateRoleWisePermission = e => {
        e.preventDefault();
        const {permission} = this.state;

        // const newPermission = permission && permission.map(m => m.value);
        // const newPermission = this.state.permission && this.state.permission.map(m => m.value).concat(this.props.user._id);

        const request = {
            // permissions:newPermission
            permissions: permission
        };
        this.props.actionAddUpdateRole(this.state.role_id, request)
        this.closeModal()
    };

    handleSelectPermission = e => this.state.permission.filter(p => p === e.target.value).length ?
        this.setState({permission: [...this.state.permission.filter(p => p !== e.target.value)]})
        :
        this.setState({permission: [...this.state.permission, e.target.value]});


    // this.setState({permission:[...this.state.permission,e.target.value]})

    closeModal = () => {
        document.getElementById("permission-close") && document.getElementById("permission-close").click()
    };

    render() {
        //
        // const permissionOptions = (this.props.permissions && this.props.permissions.length > 0) && this.props.permissions.map(c => ({
        //     value: c._id,
        //     label:
        //         <Tooltip
        //         clickToOpen={true}
        //         triggerText={c.name}
        //     >
        //             {c.name}
        // </Tooltip>
        //
        // }));
        const permissionOptions = (this.props.permissions && this.props.permissions.length > 0) && this.props.permissions.map(c => ({
            value: c._id,
            label: c.name
        }));

        const columns = [
            {
                name: "Role",
                selector: "name",
                sortable: true,
                center: true
            },
            {
                name: "",
                selector: "_id",
                sortable: true,
                right: true,
                cell: row => <div className="d-flex align-items-center user-list-icon">
                    {/*<Link className="text-warning" onClick={()=>this.setState({formModal:!this.state.formModal,user_id:row.user_id})}
                    ><i className="fa fa-info"/></Link>*/}
                    <a>
                        <i className="fa fa-edit fa-lg" id="openRoleModal"
                           data-toggle="modal"
                           data-tip data-for="AddGroup"
                           data-target="#roleModal"
                           data-backdrop="static" data-keyboard="false" onClick={() => {
                            this.setState({role_id: row._id, permission: []});
                            this.props.actionGetSingleRoleDetails(row._id);
                        }}/></a>

                </div>
            }
        ];

        return (
            <Fragment>
                <CommanSidebar/>
                <div className="content">
                    <Card className="mt-5">
                        <CardHeader
                            className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                            <div className='d-flex mt-md-0 mt-1 justify-content-between'>
                                <CardTitle tag='h4'>Permission</CardTitle>
                                {/*<Link to="/add-user">*/}
                                {/*<Button className='ml-2'>*/}
                                {/*<i className="fa fa-plus"/>*/}
                                {/*<span className='align-middle ml-50'>Add New User</span>*/}
                                {/*</Button>*/}
                                {/*</Link>*/}
                            </div>
                        </CardHeader>
                        <Row className='justify-content-end mx-0'>
                            <Col className='d-flex align-items-center justify-content-end mt-1' lg="3" md='3' sm='12'>
                                <Label className='mr-1' for='search-input'>
                                    Search
                                </Label>
                                <Input
                                    className='dataTable-filter mb-50 '
                                    type='text'
                                    // bsSize='sm'
                                    id='search-input'
                                    // value={searchValue}
                                    // onChange={this.handleFilter}
                                    onChange={(e) => {
                                        let newFilterText = e.target.value;
                                        const agents = this.props.role && this.props.role.filter(
                                            (item) =>
                                                (item.name &&
                                                    item.name.toLowerCase().includes(newFilterText.toLowerCase()))
                                        );
                                        this.setState({searchValue: newFilterText, allUsers: agents});
                                    }}

                                    //onClear={this.handleClear}
                                    value={this.state.searchValue}
                                />
                            </Col>
                        </Row>
                        <DataTable
                            noHeader
                            pagination
                            columns={columns}
                            paginationPerPage={7}
                            className='react-dataTable'
                            //sortIcon={<Icon.ChevronDown size={10}/>}
                            // paginationDefaultPage={currentPage + 1}
                            // paginationComponent={this.CustomPagination}
                            data={this.state.allUsers && this.state.allUsers.filter(f => f.name !== "Admin")}
                            // selectableRowsComponent={BootstrapCheckbox}
                        />
                        {this.props.agentsLoader && <div className="text-center">Loading...</div>}
                    </Card>
                    <Fragment>
                        <div className="modal fade" id="roleModal" role="dialog" data-backdrop="static"
                             data-keyboard="false"
                             aria-labelledby="profilePictureUploadTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered modal-md" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLongTitle">Add Permission</h5>
                                        <button type="button" id={'permission-close'} className="close"
                                                data-dismiss="modal"
                                                aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body text-center ">
                                        <div className="row">
                                            <div className="col-12">
                                                <Label className="float-left">Select Permission</Label>
                                            </div>
                                            <div className="col-12">
                                                {/*<FormGroup>*/}
                                                {/*<Select*/}
                                                {/*name="role"*/}
                                                {/*value={this.state.permission}*/}
                                                {/*onChange={(selected) => {*/}
                                                {/*console.log(selected,"selected");*/}
                                                {/*if(selected[selected.length-1].label.props){*/}
                                                {/*this.setState({*/}
                                                {/*permission: [...this.state.permission,{label:selected[selected.length-1].label.props.triggerText,value:selected[selected.length-1].value}],*/}
                                                {/*})*/}
                                                {/*}*/}
                                                {/*else {*/}
                                                {/*this.setState({*/}
                                                {/*permission: selected,*/}
                                                {/*})*/}
                                                {/*}*/}

                                                {/*}}*/}
                                                {/*options={permissionOptions}*/}
                                                {/*isMulti*/}
                                                {/*/>*/}
                                                {/*/!*<span className="text-danger">{errors.role}</span>*!/*/}
                                                {/*</FormGroup>*/}

                                            </div>
                                            {(!this.props.permissionLoader && this.props.permissions && this.props.permissions.length > 0) ? this.props.permissions.map((data, index) =>
                                                <div className="row col-12 px-5" key={index}>
                                                    <div
                                                        className="form-check d-flex align-items-center cursor-pointer py-1">
                                                        <input className="form-check-input cursor-pointer"
                                                               type="checkbox"
                                                               onChange={this.handleSelectPermission} value={data._id}
                                                               id={data._id}
                                                               checked={this.state.permission.find(d => d === data._id)}/>
                                                        <label className="form-check-label h6 cursor-pointer"
                                                               htmlFor={data._id}>
                                                            {data.name}
                                                        </label>
                                                    </div>
                                                </div>
                                            ) : this.props.permissionLoader ?
                                                <Fragment>
                                                    <SelectBoxListLoader/>
                                                    <SelectBoxListLoader/>
                                                    <SelectBoxListLoader/>
                                                    <SelectBoxListLoader/>
                                                </Fragment> :
                                                <DataNotFound message={"Not Found"}/>}

                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-success"
                                                onClick={this.handleAddUpdateRoleWisePermission}>Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    permissionLoader: state.profile.permissionLoader,
    permissions: state.profile.permissions,
    roleLoader: state.profile.roleLoader,
    role: state.profile.role,
    singleRoleDetails: state.profile.singleRoleDetails,
});


export default connect(mapStateToProps, {
    actionGetPermissions,
    actionGetRole,
    actionGetSingleRoleDetails,
    actionAddUpdateRole,
})(Permission)
